









































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import FileSaver from 'file-saver'
import RemuneracaoMedicaApi from '@/Apis/RemuneracaoMedica/Services/RemuneracaoMedicaApi'
import EventBus from '@/plugins/EventBus'

@Component({
  filters: {
    currency(value: number) {
      if (value == null) return 'R$ 0,00'
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
    },
    number(value: number) {
      if (value == null) return '0'
      return new Intl.NumberFormat('pt-BR').format(value)
    },
  },
})
export default class FinanceiroAgrupamentos extends Vue {
  filtros: any = {
    fontePagadoraId: null,
    anoMesReferencia: null,
    repassesQueSolicitamNF: null,
    periodoCriacaoInicio: null,
    periodoCriacaoFim: null,
    numeroChamado: null,
  }

  menuMesReferencia = false
  menuPeriodoInicio = false
  menuPeriodoFim = false

  rpaOpcoes = [
    { text: 'RPA (não solicita NF)', value: false },
    { text: 'Não RPA (solicita NF)', value: true },
  ]

  fontesPagadoras: any[] = []
  itens: any[] = []
  totalRegistros = 0
  pagina = 1
  qtdPorPagina = 50
  loading = false
  pesquisado = false

  downloadingId: string | null = null

  modalDetalhes = false
  detalheCarregando = false
  detalhe: any = null

  modalEditarChamado = false
  edicao: any = { id: '', numeroChamado: '' }
  formChamadoValido = true
  salvandoChamado = false

  headers = [
    { text: 'Fonte pagadora', value: 'fontePagadoraNome', align: 'left', sortable: false },
    { text: 'Mês ref.', value: 'anoMesReferencia', align: 'center', sortable: false },
    { text: 'RPA', value: 'repassesQueSolicitamNF', align: 'center', sortable: false },
    { text: 'Qtd repasses', value: 'quantidadeRepasses', align: 'center', sortable: false },
    { text: 'Valor total', value: 'valorTotalAgrupado', align: 'right', sortable: false },
    { text: 'Criado por', value: 'criadoPorNome', align: 'center', sortable: false },
    { text: 'Criado em', value: 'createdOn', align: 'center', sortable: false },
    { text: 'Nº chamado', value: 'numeroChamado', align: 'center', sortable: false },
    { text: 'Última alt.', value: 'ultimaAlteracaoChamadoEm', align: 'center', sortable: false },
    { text: 'Ações', value: 'acoes', align: 'center', sortable: false },
  ]

  headersRepasses = [
    { text: 'Nº repasse', value: 'numeroRepasse', sortable: false },
    { text: 'Prestador', value: 'prestadorNome', sortable: false },
    { text: 'Empresa médica', value: 'empresaMedicaNome', sortable: false },
    { text: 'Fonte pagadora', value: 'fontePagadoraNome', sortable: false },
    { text: 'Nº nota', value: 'numeroNota', sortable: false },
    { text: 'Valor', value: 'valorNotaFiscal', align: 'right', sortable: false },
    { text: 'Situação', value: 'situacao', align: 'center', sortable: false },
  ]

  headersHistorico = [
    { text: 'Quando', value: 'alteradoEm', sortable: false },
    { text: 'Por', value: 'alteradoPorNome', sortable: false },
    { text: 'De', value: 'numeroChamadoAnterior', sortable: false },
    { text: 'Para', value: 'numeroChamadoNovo', sortable: false },
  ]

  get anoMesReferenciaFormatado() {
    if (!this.filtros.anoMesReferencia) return ''
    return moment(this.filtros.anoMesReferencia, 'YYYY-MM').format('MM/YYYY')
  }

  get paginas() {
    return Math.ceil(this.totalRegistros / this.qtdPorPagina)
  }

  formatarData(value: string | null) {
    if (!value) return ''
    return moment(value).format('DD/MM/YYYY')
  }

  formatarDataHora(value: string | null) {
    if (!value) return ''
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  formatarMesAno(value: string | null) {
    if (!value) return '-'
    return moment(value).format('MM/YYYY')
  }

  rotuloRpa(value: boolean | null | undefined) {
    if (value === null || value === undefined) return '-'
    return value ? 'Não RPA' : 'RPA'
  }

  onChangePagina(novaPagina: number) {
    this.pagina = novaPagina
    this.buscar()
  }

  async pesquisar() {
    this.pagina = 1
    await this.buscar()
  }

  async buscar() {
    this.loading = true
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
      }
      if (this.filtros.fontePagadoraId) params.fontePagadoraId = this.filtros.fontePagadoraId
      if (this.filtros.anoMesReferencia) {
        params.anoMesReferencia = moment(this.filtros.anoMesReferencia, 'YYYY-MM').startOf('month').toISOString()
      }
      if (this.filtros.repassesQueSolicitamNF !== null && this.filtros.repassesQueSolicitamNF !== undefined) {
        params.repassesQueSolicitamNF = this.filtros.repassesQueSolicitamNF
      }
      if (this.filtros.periodoCriacaoInicio) params.periodoCriacaoInicio = this.filtros.periodoCriacaoInicio
      if (this.filtros.periodoCriacaoFim) params.periodoCriacaoFim = this.filtros.periodoCriacaoFim
      if (this.filtros.numeroChamado) params.numeroChamado = this.filtros.numeroChamado

      const response: any = await RemuneracaoMedicaApi.getAgrupamentos(params)
      if (response.success) {
        this.itens = response.data.itens || []
        this.totalRegistros = response.data.totalRegistros || 0
        this.pesquisado = true
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao carregar agrupamentos.', icon: 'warning', color: '#C62828' })
      }
    } finally {
      this.loading = false
    }
  }

  async abrirDetalhes(item: any) {
    this.modalDetalhes = true
    this.detalheCarregando = true
    this.detalhe = null
    try {
      const response: any = await RemuneracaoMedicaApi.getAgrupamentoDetalhe({ id: item.id })
      if (response.success) {
        this.detalhe = response.data
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao carregar detalhes.', icon: 'warning', color: '#C62828' })
      }
    } finally {
      this.detalheCarregando = false
    }
  }

  abrirEditarChamado(item: any) {
    this.edicao = { id: item.id, numeroChamado: item.numeroChamado || '' }
    this.modalEditarChamado = true
  }

  async salvarChamado() {
    const form = this.$refs.formChamado as any
    if (form && !form.validate()) return
    this.salvandoChamado = true
    try {
      const response: any = await RemuneracaoMedicaApi.atualizarAgrupamento(this.edicao)
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Número do chamado atualizado.', icon: 'check', color: '#2E7D32' })
        this.modalEditarChamado = false
        await this.buscar()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro ao atualizar.', icon: 'warning', color: '#C62828' })
      }
    } finally {
      this.salvandoChamado = false
    }
  }

  async baixarPdf(item: any) {
    this.downloadingId = item.id
    try {
      const response: any = await RemuneracaoMedicaApi.downloadAgrupamento({ id: item.id })
      if (response.success) {
        const blob = new Blob([response.data], { type: 'application/pdf' })
        FileSaver.saveAs(blob, `agrupamento-${item.id.substring(0, 8)}.pdf`)
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível baixar o arquivo.', icon: 'warning', color: '#C62828' })
      }
    } catch {
      EventBus.$emit('setSnackbar', { show: true, text: 'Arquivo não encontrado ou expirado.', icon: 'warning', color: '#C62828' })
    } finally {
      this.downloadingId = null
    }
  }

  async created() {
    try {
      const response: any = await RemuneracaoMedicaApi.getFontePagadoraAll()
      if (response.success) this.fontesPagadoras = response.data
    } catch {
      // ignora — select fica vazio
    }
    await this.buscar()
  }
}
